module.exports = __webpack_public_path__ + "img/aniversarios-cuarto.8ce918f1.jpg";